import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import ActionButton from "../../account/ActionButton";
import { usePayment } from "../../../context/PaymentProvider";

function DeletePaymentCardDialog() {

  const {
    removePaymentToken,
    showDeleteCardDialog,
    toggleDeleteCardDialog,
    selectedPaymentCard,
    selectPaymentCard,
  } = usePayment();

  const handleCancelDialog = () => {
    selectPaymentCard(null);
    toggleDeleteCardDialog();
  };

  const handleConfirmRemove = () => {
    if (selectedPaymentCard) {
      removePaymentToken(selectedPaymentCard.paymentTokenId);
      console.log("Payment card removed with ID:", selectedPaymentCard.paymentTokenId);
      selectPaymentCard(null);
      toggleDeleteCardDialog();
    };
  };

  return (
    <Dialog
      open={showDeleteCardDialog}
      onClose={toggleDeleteCardDialog}
      sx={{ textAlign: "center", padding: "20px" }}
    >
      <PriorityHighOutlinedIcon
        sx={{
            width: "55px",
            height: "55px",
            mt: "20px",
            mx: "auto",
            borderColor: 'primary.main',
            borderWidth: "5px",
            borderRadius: "50%",
            display: "block",
        }}
      />

      <DialogTitle sx={{ fontSize: "30px", fontWeight: "600", textAlign: "center" }}>
        Remove Card
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
        <DialogContentText sx={{ color: "#000" }}>
          Are you sure you want to permanently remove your saved card from your account? Once deleted, we will no longer store any information related to this card.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ display: "flex", justifyContent: "center", paddingBottom: "20px" }}>
        <ActionButton
          sx={{
            mr: 2
          }}
          variant='contained'
          buttonColor='secondary.main'
          buttonTextColor='primary.contrastText'
          borderColor='transparent'
          hoverColor='primary.contrastText'
          hoverBorderColor='secondary.main'
          hoverTextColor='secondary.main'
          buttonTitle='Remove'
          onClick={handleConfirmRemove}
        />
        <ActionButton
          borderColor='primary.dark'
          buttonColor='transparent'
          buttonTextColor='primary.dark'
          buttonTitle='Cancel'
          variant='outlined'
          hoverColor='primary.dark'
          hoverBorderColor={"primary.dark"}
          hoverTextColor='secondary.contrastText'
          onClick={handleCancelDialog}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeletePaymentCardDialog;